import "../scss/index.scss";

const { 
    define_svg_element,
    define_footer_element,
} = require('./lib/ushiya/custom_element');

define_svg_element();   
define_footer_element();

const {
    init_scrollbar
} = require('./sub/misc/init_scrollbar.js');

let list_year_pathpart=[
    "\/nagoya_italy\/",
    "",
    "\/list_year.html",
];

const get_contest_year=()=>{

    const {
        origin,
        pathname
    } = new URL(window.location);

    let ary_match;
    let pattern;

    let contest_year;

    contest_year = document.body.dataset['defaultYear'];

    pattern = new RegExp(`${list_year_pathpart[0]}([0123456789]{4})${list_year_pathpart[2]}`);

    ary_match = pathname.match(pattern);
    if(ary_match){
        contest_year = ary_match[1];
    }
    return contest_year
}

window.addEventListener('DOMContentLoaded',async (event)=>{

    let contest_year;

    contest_year = get_contest_year();

    if(contest_year){
        let d;
        let s=`[data-year="${contest_year}"]`;
        d = document.querySelector(s);
        if(d){
            d.classList.add("hide");
        }

    }


    init_scrollbar();
});